import { Expose, plainToInstance } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsNumberString, IsOptional, IsString, Length } from 'class-validator';

import { UF } from '@usucampeao/interfaces';

import { PropertyDto } from '../property/property.dto';

export class AddressDto {
  @Expose()
  @IsNumberString()
  @IsNotEmpty()
  @Length(8, 8)
  zipCode: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  street: string;

  @Expose()
  @IsNumberString()
  @IsNotEmpty()
  number: string;

  @Expose()
  @IsString()
  @IsOptional()
  complement?: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  neighborhood: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  city: string;

  @Expose()
  @IsEnum(UF)
  @IsNotEmpty()
  state: UF;

  /**
   * Cria uma nova instância de AddressDto a partir de dtos
   * @param props DTO de Owner
   * @returns nova instância de AddressDto
   */
  static from(props: PropertyDto | Partial<PropertyDto>): AddressDto {
    return plainToInstance(AddressDto, props.address, { exposeUnsetFields: false, excludeExtraneousValues: true });
  }
}
